import { useState, useEffect } from "react";
import Turnstile, { useTurnstile } from "react-turnstile";

export default function TurnstileWidget({ onVerification }) {
  const [theme, setTheme] = useState("dark");
  const [language, setLanguage] = useState("en");
  const turnstile = useTurnstile();

  useEffect(() => {
    const collection = document.getElementsByClassName("App");
    const darkMode = collection[0]?.classList?.contains("dark");
    setTheme(darkMode ? "dark" : "light");
    const language = localStorage.getItem("i18nextLng");
    setLanguage(language);
  }, []);

  return (
    <Turnstile
      sitekey="0x4AAAAAAAiMmzifjkRoDU7u"
      theme={theme}
      language={language}
      onVerify={(token) => {
        onVerification(true);
      }}
      onError={(error) => {
        console.error(error);
        onVerification(false);
      }}
      onExpire={() => {
        turnstile.reset();
        onVerification(false);
      }}
      onTimeout={() => {
        turnstile.reset();
        onVerification(false);
      }}
    />
  );
}
